import { render } from "./PartiallyRejectedOrders.vue?vue&type=template&id=12b48f41"
import script from "./PartiallyRejectedOrders.vue?vue&type=script&lang=js"
export * from "./PartiallyRejectedOrders.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/orders/PartiallyRejectedOrders.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "12b48f41"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('12b48f41', __exports__)) {
    console.log('reload')
    api.reload('12b48f41', __exports__)
  }
  
  module.hot.accept("./PartiallyRejectedOrders.vue?vue&type=template&id=12b48f41", () => {
    console.log('re-render')
    api.rerender('12b48f41', render)
  })

}


export default __exports__